<script lang="ts" setup>
import type { CatalogFastPropertyFilter } from '~/utils/catalogFastFilters';
import { getVisibleCatalogFastFilterOptions, selectCatalogFastFilterQuery } from '~/utils/catalogFastFilters';

const props = defineProps<{ filter: CatalogFastPropertyFilter }>();
const route = useRoute();
const visibleOptions = computed(() => getVisibleCatalogFastFilterOptions(props.filter, route.query));

function toggleFilter(value: string | number) {
  return navigateTo({
    path: route.path,
    query: selectCatalogFastFilterQuery(route.query, props.filter.slug, value),
  });
}
</script>

<template>
  <section
    v-if="visibleOptions.length"
    class="category-fast-property-filters categories-grid"
    :aria-label="filter.title"
  >
    <button
      v-for="option in visibleOptions"
      :key="option.value"
      class="category-fast-property-filters__item"
      type="button"
      @click="toggleFilter(option.value)"
    >
      <CardBlock class="category-fast-property-filters__card">
        <img
          v-if="option.fast_filter_image_url"
          :alt="option.text"
          :src="option.fast_filter_image_url"
          class="size-6 sm:size-12"
        />

        <span class="text-sm">
          {{ option.text }}
        </span>
      </CardBlock>
    </button>
  </section>
</template>

<style lang="scss" scoped>
.category-fast-property-filters {
  &__item {
    width: 100%;
    text-align: left;

    &:focus-visible {
      outline: 2px solid $black;
      outline-offset: 2px;
    }
  }

  &__card {
    display: flex;
    gap: 16px;
    align-items: center;
    height: 50px;
    padding-right: 8px;
    padding-left: 8px;
    transition:
      transform 0.2s,
      border-color 0.2s;

    @include screen-sm {
      height: 74px;
      padding-right: 12px;
      padding-left: 12px;
    }

    @apply shadow-lg;

    &:hover {
      @apply shadow-md translate-y-0.5;
    }
  }
}
</style>
